const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20video%20thumbnail%20style%20with%20neon%20green%20play%20button%2C%20entertainment%20breaking%20news%20aesthetic%2C%20dramatic%20lighting%20on%20dark%20background%2C%20cinematic%20composition%2C%20video%20player%20interface&width=600&height=338&seq=media-01-celebrity-video&orientation=landscape',
    duration: '05:32',
    title: '顶流女星片场发脾气全程录像曝光',
    views: '12.8万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20video%20player%20interface%20on%20dark%20background%20with%20neon%20green%20play%20icon%2C%20scandal%20expose%20style%2C%20dramatic%20thumbnail%20aesthetic%2C%20minimal%20dark%20composition&width=600&height=338&seq=media-02-scandal-video&orientation=landscape',
    duration: '08:15',
    title: '网红直播间口误说出惊天秘密',
    views: '9.6万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20paparazzi%20style%20video%20thumbnail%20with%20neon%20green%20glow%2C%20night%20scene%20aesthetic%2C%20breaking%20news%20alert%20design%2C%20minimal%20composition%2C%20dramatic%20atmosphere&width=600&height=338&seq=media-03-paparazzi-video&orientation=landscape',
    duration: '03:47',
    title: '狗仔队拍到当红小生与经纪人激烈争吵',
    views: '7.3万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20interview%20style%20video%20thumbnail%20on%20dark%20background%20with%20acid%20green%20play%20button%2C%20documentary%20aesthetic%2C%20minimal%20dark%20composition%2C%20professional%20video%20production&width=600&height=338&seq=media-04-interview-video&orientation=landscape',
    duration: '12:20',
    title: '独家专访：退圈艺人讲述行业内幕真相',
    views: '15.1万次播放',
  },
];

export default function Media() {
  return (
    <section id="media" className="relative py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
            <i className="ri-vidicon-line text-[10px]"></i>
            爆料视频
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
            热门 <span className="font-heading italic text-accent-400">视频爆料</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-3 max-w-lg mx-auto">
            高清视频直击爆料现场，沉浸式体验吃瓜的每一刻
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 aspect-video cursor-pointer"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-background-50/20 group-hover:bg-background-50/10 transition-colors"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-500/90 text-background-950 group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </span>
              </div>
              <span className="absolute top-3 right-3 px-2 py-0.5 bg-background-950/80 text-foreground-100 text-[10px] font-medium rounded-md whitespace-nowrap">
                {item.duration}
              </span>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/90 to-transparent p-4">
                <h3 className="text-sm font-semibold text-foreground-50 group-hover:text-accent-400 transition-colors line-clamp-1 mb-1">
                  {item.title}
                </h3>
                <span className="text-[11px] text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}